import { memo } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import type { WithSlots } from "types";
import { CustomAvatar, type CustomAvatarProps } from "lib/custom-avatar";

export type AccountProps = WithSlots<
    BoxProps,
    {
        readonly avatar: CustomAvatarProps;
    }
>;

const Account = ({ children, slotProps, ...props }: AccountProps) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateColumns: 'min-content auto',
            gap: 3,
            alignItems: 'center',
            ...props.sx
        }}
    >
        <CustomAvatar
            {...slotProps?.avatar}
        />
        <Box
            sx={{
                fontFamily: 'var(--primary-font)'
            }}
        >
            {children}
        </Box>
    </Box>
);

export default memo(Account);
